export default __webpack_public_path__ + "static/media/invision.18a465ba.svg";